export enum LogoutReason {
  appInitError = 'appInitError',
  failedToRefreshTokens = 'failedToRefreshTokens',
  failedToLoadProfile = 'failedToLoadProfile',
  creatingNewPassword = 'creatingNewPassword',
  inactivity = 'inactivity',
  userLoggedOut = 'userLoggedOut',
}
